import type { Config } from 'driver.js';
import { i18n } from '../../i18n';

export const createDefaultTutorialConfig = (overrides?: Partial<Config>): Config => ({
  animate: true,
  showProgress: true,
  progressText: '{{current}} / {{total}}',
  nextBtnText: i18n.t('button.next'),
  prevBtnText: i18n.t('button.prev'),
  doneBtnText: i18n.t('button.done'),
  popoverClass: 'tezport-tutorial-popover',
  overlayColor: 'rgba(19, 21, 35, 0.7)',
  overlayOpacity: 0.7,
  stageRadius: 8,
  stagePadding: 8,
  smoothScroll: true,
  allowClose: true,
  disableActiveInteraction: true,
  ...overrides,
});
